<!-- WRAPPER -->
<div class="mx-2 mb-2 p-1 border rounded border-solid border-gray-300
dark:border-gray-500 font-semibold text-base text-gray-500 dark:text-gray-200">
<!-- TABS REPORTES -->
<div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center 1 border rounded border-solid border-gray-300 cursor-pointer">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" (click)="toggleTabs(1)"
            [ngClass]="{'active': openTab !== 1, ' activate ': openTab === 1}">
             Turno
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center border rounded border-solid border-gray-300 cursor-pointer">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" (click)="toggleTabs(2)"
            [ngClass]="{'active': openTab !== 2, ' activate': openTab === 2}">
             Dia
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center border rounded border-solid border-gray-300 cursor-pointer">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" (click)="toggleTabs(3)"
            [ngClass]="{'active': openTab !== 3, 'activate ': openTab === 3}">
             Carril
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center border rounded border-solid border-gray-300 cursor-pointer">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" (click)="toggleTabs(4)"
            [ngClass]="{'active': openTab !== 4, 'activate ': openTab === 4}">
             Transportista
          </a>
        </li>
      </ul>
      <div class="relative min-w-0 break-words bg-transparent w-full mb-6 shadow-lg rounded">
        <div class="px-4 py-5 flex-auto bg-transparent">
          <div class="tab-content tab-space">
            <!-- Reporte Turno -->
            <div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}">
                <app-reporte-turno></app-reporte-turno>
            </div>
             <!-- Reporte Dia -->
            <div [ngClass]="{'hidden': openTab !== 2, 'block': openTab === 2}">
               <app-reporte-dia></app-reporte-dia>
            </div>
             <!-- Reporte Carril -->
            <div [ngClass]="{'hidden': openTab !== 3, 'block': openTab === 3}">
              <app-reporte-carril></app-reporte-carril>
            </div>
              <!-- Reporte Transportista -->
              <div [ngClass]="{'hidden': openTab !== 4, 'block': openTab === 4}">
                <app-reporte-transportista></app-reporte-transportista>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</div>
 
